import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-070c8381"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section url" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title sub-title" }, "URL", -1))
const _hoisted_3 = { class: "table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmInput = _resolveComponent("ConfirmInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("table", _hoisted_3, [
      _createElementVNode("tbody", null, [
        _createVNode(_component_ConfirmInput, {
          name: '掲載ページのURL',
          value: _ctx.state.pageUrl,
          class: _normalizeClass('pageUrl')
        }, null, 8, ["value"]),
        _createVNode(_component_ConfirmInput, {
          name: 'コンテンツファイルのURL',
          value: _ctx.state.fileUrl,
          class: _normalizeClass('fileUrl')
        }, null, 8, ["value"])
      ])
    ])
  ]))
}